export default "__VITE_ASSET__DSuKn2St__"